import React, { useState } from "react";
import { SidePanel } from "../../../components";
import { postAPI } from "../../../../Api";
import { logger, toaster } from "../../../../Utils";
import { useSelector } from "react-redux";
import StripeProvider from "../../../components/StripePaymentForm";

const log = logger("PaymentMethod");

const PaymentMethod = (props) => {
  const { isShow, handleClose, advertisement_payment_id, setPaymentSuccessModal } = props;
  const [isProcessing, setIsProcessing] = useState(false);
  
  const propertyDetails = useSelector(state => state.propertyDetailsReducer.propertyDetails);
  const property_id = propertyDetails && propertyDetails.id;
  const unitDetails = useSelector(state => state.propertyDetailsReducer.unitDetails);
  const property_details_id = unitDetails && unitDetails.id;

  const handleSubmitPayment = (paymentMethodId, billingDetails) => {
    setIsProcessing(true);
    
    const url = '/landlord/create-listing/process-payment';
    const data = {
      payment_method_id: paymentMethodId,
      property_id: property_id,
      property_details_id: property_details_id,
      advertisement_payment_id: advertisement_payment_id,
      billing_details: {
        address: billingDetails.address,
        country: billingDetails.country,
        province: billingDetails.province,
        postal_code: billingDetails.postalCode,
      },
    };
    
    log.info("Submitting payment:", data);
    
    postAPI(url, data)
      .then(response => {
        setIsProcessing(false);
        
        if (response.response) {
          // Error handling for Axios error responses
          log.error("Payment API error:", response.response);
          
          if (response.response.status === 422) {
            // Validation errors
            const errorEntries = Object.keys(response.response.data.errors || {});
            const errorMessages = errorEntries.map(key => response.response.data.errors[key]).flat();
            errorMessages.forEach(msg => toaster('error', msg));
          } else if (response.response.status === 400) {
            // Bad request errors
            const errorMessage = response.response.data.message || 
                                (response.response.data.error ? response.response.data.error : 'Payment failed');
            toaster('error', errorMessage);
          } else {
            // Other errors
            toaster('error', `Error: ${response.response.status} - ${response.response.statusText || 'Unknown error'}`);
          }
        } else if (response.status === 200 && response.data && response.data.status === true) {
          // Success case
          log.info("Payment successful:", response.data);
          handleClose();
          setPaymentSuccessModal(true);
        } else {
          // Unexpected response format
          log.error("Unexpected API response:", response);
          toaster('error', 'Something went wrong with the payment process!');
        }
      })
      .catch(error => {
        setIsProcessing(false);
        log.error("Payment processing error:", error);
        toaster('error', 'Payment processing failed. Please try again.');
      });
  };

  const handleCancel = () => {
    handleClose();
  };

  return (
    <SidePanel
      isShow={isShow}
      isHide={handleClose}
      title="Payment Method">
      <StripeProvider 
        onSubmit={handleSubmitPayment}
        onCancel={handleCancel}
        isProcessing={isProcessing}
      />
    </SidePanel>
  );
};

export default PaymentMethod;